export const pricingRoute = () => '/pricing';
export const checkoutRoute = () => '/checkout';
